import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import MenuIcon from "@mui/icons-material/Menu";

function KpiTileOptions({
  handleCopyModalOpen,
  handleDetailsModalOpen,
  // handleRenameModalOpen,
  isOwner = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, handler) => {
    handleClose(event);
    if (typeof handler === "function") {
      handler();
    }
  };

  const menuItems = [
    {
      label: "View Details",
      onClick: (event) => {
        handleMenuItemClick(event, handleDetailsModalOpen);
      },
      icon: <VisibilityIcon />,
    },
    {
      label: "Make a Copy",
      onClick: (event) => {
        handleMenuItemClick(event, handleCopyModalOpen);
      },
      icon: <ContentCopyIcon />,
    },
    // {
    //   label: "Rename",
    //   onClick: (event) => {
    //     handleMenuItemClick(event, handleRenameModalOpen);
    //   },
    //   icon: <DriveFileRenameOutlineIcon />,
    //   ownerOnly: true,
    // },
  ];

  const isMenuItemDisabled = (menuItem) => menuItem.ownerOnly && !isOwner;

  return (
    <>
      <MoreHorizIcon
        sx={{
          p: 0,
          ":hover": {
            cursor: "pointer",
          },
        }}
        onClick={handleClick}
      >
        <MenuIcon />
      </MoreHorizIcon>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        {menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.label}
            onClick={menuItem.onClick}
            disabled={isMenuItemDisabled(menuItem)}
          >
            <ListItemIcon>{menuItem.icon}</ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              {menuItem.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default KpiTileOptions;
